// removed by extract-text-webpack-plugin
module.exports = {"this":"_32L4Rq5R--1bz5hp70f7q8","promptBox":"DvzuCkoKSCCCNgkKf8i5J","bounce":"_93NChoBxkRk76ZwtqamGn","shade":"KLj1_t5TBOme-blBiz9y_"};


//////////////////
// WEBPACK FOOTER
// ./src/frame/ui/popup/Toast.scss
// module id = 608
// module chunks = 12